import { render, staticRenderFns } from "./Instalaciones.vue?vue&type=template&id=6c973386&"
import script from "./Instalaciones.vue?vue&type=script&lang=js&"
export * from "./Instalaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports